import React from "react";
import GenericModal from "./GenericModal";
import useModalStore from "../../stores/modalStore";
import TrendGraph from "../sections/TrendGraph";


const TrendGraphModal = ({ title, data, xKey, yKey }) => {
    const show = useModalStore(state => state.showTrendGraphModal);
    const closeModal = useModalStore(state => state.closeModal);

    if (!show || !data?.length) return null;

    return (
        <GenericModal
            name="trendGraphModal"
            title={title}
            hideButton={true}
            stickyFooter={
                <div className="flex justify-end">
                    <button
                        onClick={() => closeModal("trendGraphModal")}
                        className="!px-4 !py-2 !text-sm !font-medium !text-gray-600 !bg-transparent !border !border-gray-200 !rounded-xl hover:!bg-gray-50 !transition-colors"
                    >
                        Close
                    </button>
                </div>
            }
        >
            <TrendGraph data={data} xKey={xKey} yKey={yKey} />
        </GenericModal>
    );
};

export default TrendGraphModal;
